import { render } from "./replacementQuote.vue?vue&type=template&id=5bb0cc80"
import script from "./replacementQuote.vue?vue&type=script&lang=js"
export * from "./replacementQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__